import { getSiteMap } from '@gik/api/legal';
import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { PageHeadKeys } from '@gik/core/hocs/PageHeadKeys';
import { withTitle } from '@gik/core/hocs/withTitle';
import { InkindsSitemapPage } from '@gik/core/pages/InkindsSitemap';
import Head from '@/components/Head';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function InkindsSitemapPageComp({
  fallback,
  page,
  perPage,
}: FallbackProps<unknown> & { page: number; perPage: number }) {
  const siteMapData = fallback?.['site-map'];
  return withTitle(
    'Inkind Pages Sitemap',
    <SWRConfig value={{ fallback }}>
      <Head>
        <meta name="robots" key={PageHeadKeys.META_ROBOTS} content="index,follow" />
      </Head>
      {/* @ts-ignore */}
      <InkindsSitemapPage
        page={page}
        perPage={perPage}
        // @ts-ignore
        siteMapData={siteMapData}
      />
    </SWRConfig>
  );
}

InkindsSitemapPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

export async function getServerSideProps(context) {
  const { page = 0, per_page = 1000 } = context.query || {};
  const siteMap = getSiteMap();
  const json = await siteMap.json;
  return {
    props: {
      fallback: { 'site-map': json },
      page: Number(page),
      perPage: Number(per_page),
    },
  };
}
